import { render } from "./ShareViaModal.vue?vue&type=template&id=6641d8f5&scoped=true"
import script from "./ShareViaModal.vue?vue&type=script&lang=js"
export * from "./ShareViaModal.vue?vue&type=script&lang=js"

import "./ShareViaModal.vue?vue&type=style&index=0&id=6641d8f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6641d8f5"]])

export default __exports__